import React, { useEffect } from 'react';

import { Button, Group, Modal, useToast } from '@economic/gaudi';
import track from '../../../../../../shared/util/utilities/mixpanel';

import ExternalLink from '../../../../../../shared/components/ExternalLink';
import { ProgressDots } from '../../../../../../shared/components/ui/progressDots/ProgressDots';
import { t, tBB } from '../../../../../../shared/components/l10n/l10n';

import SignupComputerIllustration from '../../assets/Signup-computer.png';

interface Props {
    totalSteps: number;
    isDataLoading: boolean;
    onModalClose: () => void;
    next: () => void;
    anotherOnboardingAlreadyInProgress: boolean;
    cvrAlreadyOnboarded: boolean;
    allCustomersOnboarded: boolean;
}
const ConsentStep = ({
    totalSteps,
    isDataLoading,
    onModalClose,
    next,
    anotherOnboardingAlreadyInProgress,
    cvrAlreadyOnboarded,
    allCustomersOnboarded,
}: Props) => {
    const toast = useToast();

    useEffect(() => {
        track('smartpay', 'signup.modal.viewed');
    }, []);

    const onAcceptClicked = () => {
        track('smartpay', 'signup.modal.terms-agreed');
        if (typeof next === 'function') next();
    };

    const isContinueButtonDisabled = () => {
        return isDataLoading || anotherOnboardingAlreadyInProgress || cvrAlreadyOnboarded;
    };

    if (allCustomersOnboarded) {
        onModalClose();
        toast.error(t`SMARTPAY_ONBOARDING_MODAL_EXISTING_CUSTOMER_CVR_ONBOARDED_ERROR`);
    }

    return (
        <>
            <Modal.Header>
                <ProgressDots stepsCount={totalSteps} currentStep={1} withCompleteTicks={false} />
                <div className="my-4">{t`SMARTPAY_ONBOARDING_MODAL_CONSENT_TITLE`}</div>
            </Modal.Header>

            <Modal.Content>
                <div className="flex flex-col items-center modal_consentStep--content">
                    <img src={SignupComputerIllustration} alt="Smart Pay logo" className="w-48 mb-4" />
                    <span>{t`SMARTPAY_ONBOARDING_MODAL_CONSENT_PARAGRAPH_1`}</span>
                    <span>
                        {tBB('SMARTPAY_ONBOARDING_MODAL_CONSENT_PARAGRAPH_2', {
                            __LINK: content => (
                                <ExternalLink href="https://www.e-conomic.dk/sikkerhed/privacy">{content}</ExternalLink>
                            ),
                        })}
                    </span>
                    <span>{t`SMARTPAY_ONBOARDING_MODAL_CONSENT_PARAGRAPH_3`}</span>

                    {cvrAlreadyOnboarded ? (
                        <span>
                            <strong>{t`SMARTPAY_ONBOARDING_MODAL_CONSENT_ONBOARDING_CVR_ALREADY_ONBOARDED`}</strong>
                        </span>
                    ) : anotherOnboardingAlreadyInProgress ? (
                        <span>
                            <strong>{t`SMARTPAY_ONBOARDING_MODAL_CONSENT_ONBOARDING_ALREADY_IN_PROGRESS`}</strong>
                        </span>
                    ) : null}
                </div>
            </Modal.Content>
            <Modal.Footer>
                <Group>
                    <Button onClick={onModalClose}>{t`SMARTPAY_ONBOARDING_MODAL_CONSENT_CLOSE_BUTTON`}</Button>
                    <Button autoFocus appearance="primary" onClick={onAcceptClicked} disabled={isContinueButtonDisabled()}>
                        {t`SMARTPAY_ONBOARDING_MODAL_CONSENT_ACCEPT_BUTTON`}
                    </Button>
                </Group>
            </Modal.Footer>
        </>
    );
};

export default ConsentStep;
